import React, {
  FunctionComponent,
  useEffect,
  useRef,
  useState,
} from "react";
import styles from "./ContactDetails.module.css";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BiPencil } from "react-icons/bi";
import ContactButton from "../../Components/Button/ContactButton";
import { useLocation } from "react-router";
import {
  changeLeadStage,
  changeLeadStageMongo,
  fetchContactResources,
  fetchLeadTasks,
  fetchLeadTasksMongo,
  sendVerificationNotification,
  toggleis_button_called,
  fetchCallLogsMongo,
  fetchContactResourcesMongo
} from "../../Services/contacts";
import {
  getDateAndTime,
  getDateAndTimeString,
  getDateString,
  getFormattedDate,
  properFormat,
  convertSecondsToTime,
  openCustomMMBURLWithGA,
  openCustomMMBURL,
  openCustomUrl
} from "../../Values/utils";
import {
  HiVideoCamera,
  HiOutlinePhotograph,
  HiOutlineMicrophone,
  HiPhone,
  HiExternalLink,
} from "react-icons/hi";
import { ImFileText2 } from "react-icons/im";
import InterestedLeadModal from "../../Components/Modals/InterestedLeadModal/InterestedLeadModal";
import NotInterestedLeadModal from "../../Components/Modals/NotInterestedModal/NotInterestedModal";
import CallBackModal from "../../Components/Modals/CallBackModal/CallBackModal";
import LostModal from "../../Components/Modals/LostModal/LostModal";
import CreateModal from "../../Components/Modals/CreateModal/CreateModal";
import NotesModal from "../../Components/Modals/NotesModal/NotesModal";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import RescheduleModal from "../../Components/Modals/RescheduleModal/RescheduleModal";
import ImportModal from "../../Components/Modals/ImportModal/ImportContactsModal";
import ProfileImageModal from "../../Components/Modals/ProfileImageModal/ProfileImageModal";
import AttachmentModal from "../../Components/Modals/AttachmentModal/AttachmentModal";
import Loading from "../../Components/Loading/Loading";
import OwnerModal from "../../Components/Modals/ChangeOwnerModal/ChangeOwnerModal";
import axios from "axios";
import { fetchDuplicateContact, fetchCustomButtons,fetchProjectByNameFromMB } from "../../Services/organizations";
import { showSnackbarAction,setCurrentRoute } from "../../Redux/actions";
import { themeColors } from "../../Components/theme";
import { url } from "../../Values/constants";
import ApprovalModal from "../../Components/Modals/ApprovelModal/ApprovalModal";
import { sendNotification } from "../../Services/notification";
import axiosHandler from "../../Services/axiosHandler";
import { googleAnalytics, googleAnalyticsCTAClick, googleAnalyticsTabClick } from "../../Services/users";
import BoosterLeadsCard from "../../Components/Modals/BoosterLeads/BoosterLeadsCard";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import CallRecordingsPlayer from "../CallRecordingsPlayer/CallRecordingsPlayer";
import CenteredPopUp from "../../Components/CenteredPopUp/CenteredPopUp";
import BoosterMaskedLeads from "./BoosterMaskedLeads";
import HtmlBanner from "../../bannerManagement/baneerComp";
import rightArrow from "../../Assets/Images/arrow-right-red.svg";
import { backgroundImage } from "html2canvas/dist/types/css/property-descriptors/background-image";


type props = {
  user: any;
  organizationUsers: any;
  theme: any;
  authToken:any;
  organizationData:any;
  userPreference:any;
};

let usersList: any[] = [];
const ContactDetails: FunctionComponent<props> = ({
  user,
  organizationUsers,
  theme,
  authToken,
  organizationData,
  userPreference
}) => {
  const location: any = useLocation();
  // if (location.state == undefined) {
  //   window.location.href = "https://login1.read-pro.com/";
  // }
  const [tasksList, setTasksList] = useState<
    any[] | undefined
  >(undefined);
  const [taskVerified_status, setTaskVerified_status] = useState();
  const [taskReporting_to, setTaskReporting_to] = useState();
  const [owner, setOwner] = useState('');
  const [notesList, setNotesList] = useState<
    any[] | undefined
  >(undefined);
  const [attachmentsList, setAttachmentsList] = useState<
    any[] | undefined
  >(undefined);
  const [load, setLoad] = useState(false);

  // to open the custom button dropdwon if there are more than 2 custom buttoms
  const [open, setOpen] = useState(false);
  const drop = useRef(null);

  // top css property for dropdown custom button
  const top = 30;
  // margin top css property for dropdown custom button
  const topMargin = 5;

  const [callLogsList, setCallLogsList] = useState<
    any[] | undefined
  >(undefined);
  const [customButtons, setCustomButtons] = useState<
    any[] | undefined
  >(undefined);
  const [title, setTitle] = useState("");
  const [interestedModal, setInterestedModal] =
    useState(false);
  const [callbackModal, setCallbackModal] = useState(false);
  const [notInterestedModal, setNotInterestedModal] =
    useState(false);
  const [lostModal, setLostModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [rescheduleModal, setRescheduleModal] =
    useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [picModal, setPicModal] = useState(false);
  const [vidModal, setVidModal] = useState(false);
  const [fileModal, setFileModal] = useState(false);
  const [ownerButton, setOwnerButton] = useState(false);
  const [freshFilterValue, setFreshFilterValue] = useState<any>();
  const [apiQuestionsData,setApiQuestionsData] = useState<any>();
  const [dataList, setDataList] = useState<any[]>([]);
  const [isGACalled, setIsGACalled] = useState<any>(false);
  const [isMaskedBoosterLead, setIsMaskedBoosterLead] = useState<boolean>(false);
  const [showCallRecordings, setShowCallRecordings] = useState<boolean>(false);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [audioUrl, setAudioUrl] = useState('');
  const [imageMGUrl, setImageMGUrl] = useState('');
  const [handlePlayPause, setHandlePlayPause] = useState<(() => void) | null>(null);
  const [showZoomedImg, setShowZoomedImg] = useState<boolean>(false);
  const [autoToken, setAutoToken] = useState("");
  const [checkBannerActive,setCheckBannerActive]=useState(false)

  const [cRoute,setCRoute]=useState("")

  useEffect(() => {
    dispatcher(setCurrentRoute(location.pathname))
    setCRoute(location.pathname)
  }, [location]);

   const [projectMB, setProjectMB] = useState<any>({});

  useEffect(() => {
    const fetchData = async () => {
      const result:any = await fetchProjectByNameFromMB(location.state.detail.project || "NA",setProjectMB);

    
    };
    fetchData();
}, []);


  const createUsersList = (
    email: string,
    users: any[],
    uid: boolean
  ) => {
    users.map((item: any) => {
      if (usersList.includes(item)) {
        return;
      } else {
        if (
          item.reporting_to === email &&
          item.status === "ACTIVE"
        ) {
          if (!usersList.includes(item)) {
            usersList.push(item);
          }

          createUsersList(item.user_email, users, uid);
        }
      }
    });
  };

  const visit_Verification = (
    leadId: string,
    verified_status:string,
    reporting_to?: string,
    point?:string,
    // setTask: (data: any) => void,
  ) => {
    const URL = url + '/tasks/updateVerification';
    let apiData: any 
    {point==="1"?apiData = {
      "leadId":leadId,
      "verified_status":verified_status,
      "verified_at":null,
      "requested_at":new Date(),
      "reporting_to":reporting_to,
      // "filter":{"transfer_status":[false]}
    }:apiData = {
      "leadId":leadId,
      "verified_status":verified_status,
      "verified_at":new Date(),
      // "filter":{"transfer_status":[false]}
    }}
    axios
      .post(URL, apiData, {headers: {'x-access-token': authToken}})
      .then((res:any) => {
        getOrgTaskMongo(location.state.detail.contactId)
      })
      .catch((error:any) => {
      });
  };
  const visit_Verifi = (
    leadId: string,
    verified_status:string,
    uid:string,
    type:string,
    coustomer:string,
    reporting_to?: string,
    point?:string,
  ) => {
    visit_Verification( leadId,
      verified_status,
      reporting_to,
      point,
      )
      // sendVerificationNotification(user.organization_id, uid, `${user.user_first_name} ${user.user_last_name} has ${verified_status} your ${type} to Mr./Mrs. ${coustomer}`);
      sendNotification(user.organization_id, uid,'Verification Request', `${user.user_first_name} ${user.user_last_name} has ${verified_status} your ${type} to Mr./Mrs. ${coustomer}`,{
        uid: uid,
        organization_id: user.organization_id,
        message: `${user.user_first_name} ${user.user_last_name} has ${verified_status} your ${type} to Mr./Mrs. ${coustomer}`,
        screen: '',
        approveAction: 'true',
        rejectAction: 'true'
  },authToken);
    // onBack()
  };
  const getOrgTaskMongo = (
    // organization_id: string,
    lead_id: string,
  ) => {
    // const URL = url + '/tasks/getTasksOfOrg';
    const URL = url + '/tasks/getTaskById';
    let data :any[] =[]
    let apiData: any = {
      id:lead_id,
    };
    // setLoad(true)
    axios
      .post(URL, apiData, {headers: {'x-access-token': authToken}})
      .then((res:any) => {
        res.data.map((task:any)=>{
          if(task.leadId===location.state.detail.contactId){
          if(task.status==='Pending'){
          setTaskVerified_status(task.verified_status)
          if(task.verified_status==="Pending")
          {
          setTaskReporting_to(task.reporting_to)
          setOwner(task.uid)
        }}
      }})
        // setTask(data)
        // setLoad(false);
      })
      .catch((error:any) => {
        // setLoad(false);
      });
  };

  const getLeadQuestions = (
    // organization_id: string,
    lead_id: string,
  ) => {
    // const URL = url + '/tasks/getTasksOfOrg';
    const URL = url + '/apiQuestions/get';
    let apiData: any = {
      id:lead_id,
    };
    // setLoad(true)
    axios
      .post(URL, apiData, {headers: {'x-access-token': authToken}})
      .then((res:any) => {
        if(res.data && res.data.length > 0){
          setApiQuestionsData(res.data);
        }else{
          setApiQuestionsData([]);
        }
        // setTask(data)
        // setLoad(false);
      })
      .catch((error:any) => {
        // setLoad(false);
        setApiQuestionsData([]);
      });
  };

  useEffect(()=>{
    getLeadQuestions(location.state.detail.contactId)
  },[])

  useEffect(()=>{
    getOrgTaskMongo(location.state.detail.contactId)
  },[tasksList])
  useEffect(() => {
    // const subuser = fetchLeadTasks(
    //   (data) => setTasksList(data),
    //   location.state.detail.contactId
    // );

    fetchLeadTasksMongo(
      (data) => setTasksList(data),
      location.state.detail.contactId,
      authToken,
      dispatcher
    );

    fetchCallLogsMongo(
      (data) => setCallLogsList(data),
      location.state.detail.contactId,
      authToken,
      dispatcher
    );

    fetchContactResourcesMongo(
      (data) => setNotesList(data),
      (data) => setAttachmentsList(data),
      (data) => setAudioUrl(data),
      (data) => setImageMGUrl(data),
      location.state.detail.contactId,
      authToken,
      dispatcher
    );

    // const subcontacts = fetchContactResources(
    //   (data) => setNotesList(data),
    //   (data) => setAttachmentsList(data),
    //   (data) => setCallLogsList(data),
    //   location.state.detail.contactId
    // );
    const subToggleButtons = fetchCustomButtons(
      user.organization_id,
      (data) => setCustomButtons(data)
    );
    sessionStorage.setItem("org", user.organization_id);
    return () => {
      // subuser();
      // subcontacts();
      subToggleButtons();
    };
  }, [location.state, user]);

  useEffect(()=>{
    fetchContactResourcesMongo(
      (data) => setNotesList(data),
      (data) => setAttachmentsList(data),
      (data) => setAudioUrl(data),  
      (data) => setImageMGUrl(data),  
      location.state.detail.contactId,
      authToken,
      dispatcher
    );
  },[picModal,vidModal,noteModal,fileModal])

  useEffect(()=>{
    if(location.state.detail.reenquired == true){
      if (user.organization_id) {
        fetchDuplicateContact(user.organization_id,location.state.detail.contact_no, (val) => setDataList(val));
      }
    }
  },[])

  const dispatcher = useDispatch();
  const history = useHistory();

  const callCustomButton = async (
    url: string,
    parameters: any,
    headers: any,
    type: string
  ) => {

    const isObjectEmpty = (object: any) => {
      var isEmpty = true;
      for (let keys in object) {
        isEmpty = false;
        break; // exiting since we found that the object is not empty
      }
      return isEmpty;
    };

    let res;
    if (type.toLowerCase() === "post") {
      for (let key in parameters) {
        let wildcard = parameters[key].split("$");
        if (wildcard.length > 1) {
          parameters[key] =
            location.state.detail[wildcard[1]];
        }
      }

      if (!isObjectEmpty(headers)) {
        const config = {
          headers: headers,
        };
        res = await axiosHandler.post(url, parameters, config);
      } else {
        res = await axiosHandler.post(url, parameters);
      }
      dispatcher(
        showSnackbarAction(
          "Custom Button Action Successful",
          "success"
        )
      );
    } else if (type.toLowerCase() === "get") {
      res = await axiosHandler.get(url);
    }

    toggleis_button_called(location.state.detail.contactId);
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const tdStyles = {
    backgroundColor: theme ? themeColors.tdBackgroundColor : themeColors.tdBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  }

  const handleBooking = async () => {
    googleAnalyticsCTAClick("Contact Details Booking Button","Contact Details Screen",user)
    const bodyData = {
      organization_id: location.state.detail.organization_id,
      uid: location.state.detail.uid,
      contact_no: location.state.detail.contact_no,
    }
    // axios.defaults.headers.common['x-access-token'] =
    //   authToken

    const getBookingContactNORes = await axiosHandler.post(
      url + '/bookings/details',
      bodyData
    );
    if (getBookingContactNORes.data) {
      history.push({
        pathname: '/addBooking',
        state: { "booking_type": "REBOOKING", "reBookingData": bodyData }
      })
    }
    else {
      history.push({
        pathname: '/addBooking',
        state: { "Contact_details": location.state.detail, "notesList": notesList, "callLogsList": callLogsList, "attachmentsList": attachmentsList }
      })
    }
  }


  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Contact_Details_Screen',user)
      }
    }
  },[user])

  useEffect(()=>{
      if(location.state.detail.lead_sub_type === "Masked Booster Leads"){
        setIsGACalled(true)
        googleAnalyticsTabClick(
                          "Contact Detail Screen - Masked Booster Card 1st layer",
                          user
                        );
      }
  },[location.state.detail,user])

  useEffect(()=>{
    if(location.state.detail.lead_sub_type === "Masked Booster Leads"){
      setIsMaskedBoosterLead(true);
    }
  },[location.state.detail.lead_type])

  
  const handleCallback = (callback: () => void) => {
    setHandlePlayPause(() => callback);
  };

  const callRecordPlayHandler = () => {
    setShowCallRecordings(true)
    if(showCallRecordings){
      setIsPlaying(prev => !prev)
      handlePlayPause && handlePlayPause()
    }
  }

  const showZoomedImgHandler = () => {
    document.body.classList.add("no-overflow");
    setShowZoomedImg(true)
  }

    useEffect(() => {
    let userData: any = localStorage.getItem("user");
    let parsedUser = JSON.parse(userData);
    if (parsedUser.autoToken) {
      setAutoToken(parsedUser.autoToken)
    }
  }, [])

  

  const openUrl = async () => {
      try {
        googleAnalyticsCTAClick(
          "Know More",
          "Contact Detail Screen - Masked Booster Card",
          user
        );
        openCustomMMBURL(autoToken,"bricks/boosterDashboard.html?showPopup=true&intf=agent_mon_readPro_Know_More&sr=Contact_Detail_Screen_Masked_Booster_Card&pfm=WEB")
      } catch (error) {
      }
    };

      const openUrlProject = async () => {
      try {
        googleAnalyticsCTAClick(
          "Check estimated responses",
          "Project_Listing_lead_details_Banner Click",
          user
        );
        window.open(openCustomUrl(autoToken,"https://uat.magicbricks.com/serviceportal/dynamic-page?pageName=microsite_pl&utm_source=agent_mon_MMB&utm_medium=Banner&utm_campaign=Project_listing"))
      } catch (error) {
      }
    };
 
  return (
    <>
      {
        (location.state.detail.lead_sub_type == "Masked Booster Leads")
        ?
        <BoosterMaskedLeads 
          backClick={()=>{
              googleAnalyticsCTAClick("Contact Details Back Button","Contact Details Screen",user)  
              history.replace("/contacts")
          }}
          data={location.state.detail}
          onClick={() =>openUrl()}
          ctaText={"Buy Monthly Subscription"}
        />
        :
        <>
         
          <div className={styles.parent} style={containerStyles}>
            <HtmlBanner   user={user} route={cRoute} bannerType={"pageBanner"}/>
      <div className={styles.backButtonContainer}>
          <button
            style={{ display: 'inline' }}
            className={styles.addBox}
            onClick={()=>{
              googleAnalyticsCTAClick("Contact Details Back Button","Contact Details Screen",user)  
              history.replace("/contacts")
            }}
          >
            Back
          </button>
          {(location.state.detail?.stage === "WON")&&(!organizationData.business_domain || organizationData.business_domain== "Real Estate") && <button
            style={{ marginLeft: '30px', width: "15%",display: 'inline' }}
            className={styles.addBox}
            onClick={() => handleBooking()}
          >
            Booking
          </button>}
      </div>
      <div
        className={styles.child}
        style={containerStyles}
      >
        <div
          className={styles.detailsContainer}
          style={containerStyles}
        >
          {/* <button
            // style={{ marginLeft: '30px' }}
            className={styles.addBox}
            onClick={history.goBack}
          >
            Back
          </button> */}
          <div
            className={styles.contactDetails}
            style={cardContainerStyles}
          >
            <div className={styles.firstContainer}
            >

              <div className={styles.nameDiv}>
                {/* <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                  >
                    <div>
                      <button
                          className={styles.dropdownButton}
                          onClick={() => {
                            setOwnerButton(true);
                            createUsersList(
                                user.user_email,
                                organizationUsers,
                                false
                            );
                          }}
                      >
                        Change Owner
                      </button>
                    </div>
                    {customButtons &&
                    customButtons.length === 1 ? (
                        <button
                            className={styles.ownerButton}
                            onClick={() => {
                              callCustomButton(
                                  customButtons[0]?.url,
                                  customButtons[0]?.parameters,
                                  customButtons[0]?.headers,
                                  customButtons[0]?.type
                              );
                            }}
                        >
                          {customButtons[0]?.name}
                        </button>
                    ) : (
                        <div
                            className="dropdown"
                            ref={drop}
                            style={{
                              position: "relative",
                              display: "inline-block",
                            }}
                        >
                          <button
                              className={styles.dropdownButton}
                              onClick={() =>
                                  setOpen((open) => !open)
                              }
                          >
                            {!open ? "Open" : "Close"} Custom
                            buttons dropdown
                          </button>
                          {open && (
                              <>
                                {customButtons &&
                                    customButtons.map(
                                        (tb: any, index: any) => (
                                            <button
                                                style={{
                                                  position: "absolute",
                                                  top: top * (index + 1),
                                                  marginTop:
                                                      topMargin *
                                                      (2 * (index + 1) - 1),
                                                }}
                                                className={
                                                  styles.dropdownButton
                                                }
                                                onClick={() => {
                                                  callCustomButton(
                                                      tb.url,
                                                      tb.parameters,
                                                      tb.headers,
                                                      tb.type
                                                  );
                                                  setOpen(false);
                                                }}
                                            >
                                              {tb.name}
                                            </button>
                                        )
                                    )}
                              </>
                          )}
                        </div>
                    )}
                  </div> */}
                {location.state.detail.lead_sub_type==="Magicleads Gold"&&
                // <p style={{fontWeight:"bold" ,marginBottom:5,fontSize:15}}>
                <h6 style={{backgroundColor:"#ffc61a",fontSize:12,padding:"2px 5px 2px 5px",borderRadius:"4px",alignSelf:"flex-start"}}>
                  {location.state.detail.lead_sub_type}
                </h6>
                }
                <h6
                // className={styles.name}
                >
                  Name : {location.state.detail.customer_name
                    .toLowerCase()
                    .split(" ")
                    .map(function (word: any) {
                      return (
                        word.charAt(0).toUpperCase() +
                        word.slice(1)
                      );
                    })
                    .join(" ")}
                </h6>
                
                <p
                // className={styles.customerEmail}
                >
                  {location.state.detail.email}
                </p>
                
              </div>
          <div className={styles.data}>
                <p className={styles.heading}>
  Project : <span style={{ fontWeight: 500 }}>{location.state.detail.project}</span>
</p>   
              </div>
            {/* {projectMB?.leadCount && parseInt(projectMB?.leadCount) >0 && (
  <>
    <div className={styles.pltext}>
      <span className={`${styles.textbold} ${styles.textgreen}`}>
        It's a high-demand project!
      </span>{" "}
      To maximize your responses, post it with{" "}
      <span className={styles.textbold}>Project Listing</span> Pack.
    </div>

    <div className={styles.estcta} onClick={openUrlProject}>
      Check estimated responses{" "}
      <img src={rightArrow} alt="arrow" className={styles.icon20arrow} />
    </div>
  </>
)} */}

           <HtmlBanner   user={user} route={cRoute} bannerType={"contactMidView"} tagObj={location.state.detail} setCheckBannerActive={setCheckBannerActive}/>
              <div className={styles.buttonContainer}>
                {properFormat(
                  location.state.detail.stage
                ) === "Fresh" || properFormat(
                  location.state.detail.stage
                ) === "Migrated Leads" ? (
                  <>
                    <ContactButton
                      backgroundColor="#29ab87"
                      color="#fff"
                      title="Interested"
                      clicked={() => {
                        googleAnalyticsCTAClick("Contact Details Interested Button","Contact Details Screen",user)
                        setInterestedModal(true);
                      }}
                      disabled={isMaskedBoosterLead ? true : false}
                    />
                    <ContactButton
                      backgroundColor="#f7d560"
                      color="#fff"
                      title="Call Back"
                      clicked={() => {
                        googleAnalyticsCTAClick("Contact Details CallBack Button","Contact Details Screen",user)
                        setCallbackModal(true);
                      }}
                      disabled={isMaskedBoosterLead ? true : false}
                    />
                    <ContactButton
                      backgroundColor="#ff6961"
                      color="#fff"
                      title="Not-Interested"
                      clicked={() => {
                        googleAnalyticsCTAClick("Contact Details NotInterested Button","Contact Details Screen",user)
                        setNotInterestedModal(true);
                      }}
                      disabled={isMaskedBoosterLead ? true : false}
                    />
                  </>
                ) : properFormat(
                  location.state.detail.stage
                ) === "Call Back" ? (
                  <>
                    <ContactButton
                      backgroundColor="#29ab87"
                      color="#fff"
                      title="Interested"
                      clicked={() => {
                        googleAnalyticsCTAClick("Contact Details Interested Button","Contact Details Screen",user)
                        setInterestedModal(true);
                      }}
                    />
                    <ContactButton
                      backgroundColor="#f7d560"
                      color="#fff"
                      title="Callback"
                      clicked={() => {
                        googleAnalyticsCTAClick("Contact Details CallBack Button","Contact Details Screen",user)
                        setCallbackModal(true);
                      }}
                    />
                    <ContactButton
                      backgroundColor="#ff6961"
                      color="#fff"
                      title="Not-Interested"
                      clicked={() => {
                        googleAnalyticsCTAClick("Contact Details NotInterested Button","Contact Details Screen",user)
                        setNotInterestedModal(true);
                      }}
                    />
                  </>
                ) : properFormat(
                  location.state.detail.stage
                ) === "Interested" ? (
                  <>
                    <ContactButton
                      backgroundColor="#29ab87"
                      color="#fff"
                      title="Won"
                      clicked={() => {
                        googleAnalyticsCTAClick("Contact Details Won Button","Contact Details Screen",user)
                        // changeLeadStage(
                        //   location.state.detail.contactId,
                        //   { stage: "WON" },
                        //   () => { },
                        //   dispatcher,
                        //   () => { },
                        //   history,
                        //   tasksList
                        // );
                        changeLeadStageMongo(
                          location.state.detail.contactId,
                          { stage: "WON" },
                          () => { },
                          dispatcher,
                          () => { },
                          history,
                          authToken,
                          tasksList,
                          "WON",
                          user.uid,
                          {
                            "ORGANIZATION_ID": organizationData.organization_id,
                            "DISPOSITION": "Won",
                            "SUB_DISPOSITION": "Won",
                            "LEADID": location.state.detail.contactId,
                            "UID": user.uid,
                            "DATE": new Date().toISOString()
                          }
                        );
                        if(userPreference.contact_change_lead_stage_approved === true){
                          
                          if(!organizationData.business_domain || organizationData.business_domain== "Real Estate"){
                            history.replace({
                              pathname: '/addBooking',
                              state: { "Contact_details": location.state.detail, "notesList": notesList, "callLogsList": callLogsList, "attachmentsList": attachmentsList }
                            })
                          }else{
                            history.push("/")
                          }
                        }
                      }}
                    />
                    <ContactButton
                      backgroundColor="#e34234"
                      color="#fff"
                      title="Lost"
                      clicked={() => {
                        googleAnalyticsCTAClick("Contact Details Lost Button","Contact Details Screen",user)
                        setLostModal(true);
                      }}
                    />
                    <ContactButton
                      backgroundColor="#f7d560"
                      color="#fff"
                      title="Re Schedule"
                      clicked={() => {
                        googleAnalyticsCTAClick("Contact Details Re Schedule Button","Contact Details Screen",user)
                        setRescheduleModal(true);
                      }}
                    />
                    <ContactButton
                      backgroundColor="#279ea0"
                      color="#fff"
                      title="Create"
                      clicked={() => {
                        googleAnalyticsCTAClick("Contact Details Create Task Button","Contact Details Screen",user)
                        setCreateModal(true)
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}
              </div>
              <div className={styles.data} >
                <p className={styles.heading}>Requirement Type :</p>
                <p className={styles.text}>
                  {location.state.detail.requirement_Type}
                </p>
              </div>
              <div className={styles.data} >
                <p
                  className={styles.heading}
                >
                  Alternate Number :
                </p>
                <p className={styles.text}>
                  {location.state.detail.alternate_no}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>Country :</p>
                <p className={styles.text}>
                  {location.state.detail.country}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>Lead State :</p>
                <p className={styles.text}>
                  {location.state.detail.state}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>City :</p>
                <p className={styles.text}>
                  {location.state.detail.city}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>Location :</p>
                <p className={styles.text}>
                  {location.state.detail.location}
                </p>
              </div>
              {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
              <div className={styles.data}>
                <p className={styles.heading}>
                  Property Type :
                </p>
                <p className={styles.text}>
                  {location.state.detail.property_type}
                </p>
              </div>
              }
              {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
              <div className={styles.data}>
                <p className={styles.heading}>
                  Property Stage :
                </p>
                <p className={styles.text}>
                  {location.state.detail.property_stage}
                </p>
              </div>}
              <div className={styles.data}>
                <p className={styles.heading}>Budget :</p>
                <p className={styles.text}>
                  {location.state.detail.display_budget?location.state.detail.display_budget:location.state.detail.budget}
                </p>
              </div>
              
             {/* {  !projectMB?.leadCount || (projectMB?.leadCount && parseInt(projectMB?.leadCount) ===0) && ( <div className={styles.data}>
                <p className={styles.heading}>Project :</p>
                <p className={styles.text}>
                  {location.state.detail.project}
                </p>
              </div>)} */}
              <div className={styles.data}>
                <p className={styles.heading}>Property Id :</p>
                <p className={styles.text}>
                  {location.state.detail.property_id}
                </p>
              </div>
              {(organizationData.business_domain && organizationData.business_domain !== "Real Estate")&&(
                              <div className={styles.data}>
                              <p className={styles.heading}>
                              Business Vertical :
                              </p>
                              <p className={styles.text}>
                                {
                                    location.state.detail
                                      .business_vertical
                                  
                                  }
                                  {/* {"Married"} */}
                              </p>
                            </div>
              )}
              <div className={styles.data}>
                <p className={styles.heading}>
                  Not Interested Reason :
                </p>
                <p className={styles.text}>
                  {location.state.detail.not_int_reason}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                  Lost Reason :
                </p>
                <p className={styles.text}>
                  {location.state.detail.lost_reason}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                  Other Not Interested Reason :
                </p>
                <p className={styles.text}>
                  {
                    location.state.detail
                      .other_not_init_reason
                  }
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>Addset :</p>
                <p className={styles.text}>
                  {location.state.detail.addset}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                Stage Changed On :
                </p>
                <p className={styles.text}>
                  {location.state.detail.stage_change_at !==
                    ""
                    ? getDateAndTime(
                      location.state.detail
                        .stage_change_at,
                      "LLL"
                    )
                    : ""}
                </p>
              </div>
              {location.state.detail.lead_sub_type!=="Magicleads Gold" && 
              <>
              <div className={styles.data}>
                <p className={styles.heading}>
                  Gender :
                </p>
                <p className={styles.text}>
                    {location.state.detail.gender}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                Marital Status :
                </p>
                <p className={styles.text}>
                  {
                      location.state.detail
                        .marital_status
                    
                    }
                </p>
              </div>
              </>}
              {
                apiQuestionsData && apiQuestionsData[0] && 
                apiQuestionsData[0].question_1 && (
                  <div className={styles.data}>
                    <p className={styles.heading}>
                    {apiQuestionsData[0].question_1}
                    </p>
                    <p className={styles.text}>
                    {apiQuestionsData[0].answer_1 ? apiQuestionsData[0].answer_1 : ""}
                        {/* {"Married"} */}
                    </p>
                  </div>
                )
              }
                          {
                apiQuestionsData && apiQuestionsData[0] && 
                apiQuestionsData[0].question_2 && (
                  <div className={styles.data}>
                    <p className={styles.heading}>
                    {apiQuestionsData[0].question_2}
                    </p>
                    <p className={styles.text}>
                    {apiQuestionsData[0].answer_2 ? apiQuestionsData[0].answer_2 : ""}
                        {/* {"Married"} */}
                    </p>
                  </div>
                )
              }
            </div>

            <div className={styles.secondContainer}>
              <div className={styles.emailContainer}>
                <h6
                className={styles.subContainer}
                >
                  Lead Assignee Email : {
                    location.state.detail
                      .contact_owner_email
                  }
                </h6>
                <h6
                className={styles.subContainer}
                >
                  Contact Number : {location.state.detail.country_code?location.state.detail.country_code+"-"+location.state.detail.contact_no:location.state.detail.contact_no}
                </h6>
                <h6
                className={styles.subContainer}
                >
                  Address : <p className={styles.address}>{location.state.detail.address}</p>
                </h6>
              </div>
              <div className={styles.data}  style={projectMB?.leadCount && parseInt(projectMB?.leadCount) > 0 && checkBannerActive? { marginTop: "128px" } : { marginTop: "27px" }}>
                <p className={styles.heading}>Unit No :</p>
                <p className={styles.text}>
                  {location.state.detail.unit_no}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                  Next Follow Up Type :
                </p>
                <p className={styles.text}>
                  {
                    location.state.detail
                      .next_follow_up_type
                  }
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                Next Follow Up On :
                </p>
                <p className={styles.text}>
                  {location.state.detail
                    .next_follow_up_date_time !== ""
                    ? getDateAndTime(
                      location.state.detail
                        .next_follow_up_date_time,
                      "LLL"
                    )
                    : ""}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                  Lead Source :
                </p>
                <p className={styles.text}>
                  {location.state.detail.lead_source}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                  Reporting To :
                </p>
                <p className={styles.text}>
                  {location.state.detail.reporting_to}
                </p>
              </div>

              {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
              <div className={styles.data}>
                <p className={styles.heading}>
                  Property Sub Type :
                </p>
                <p className={styles.text}>
                  {location.state.detail.property_sub_type}
                </p>
              </div>}

              <div className={styles.data}>
                <p className={styles.heading}>
                  Call Back Reason :
                </p>
                <p className={styles.text}>
                  {location.state.detail.call_back_reason}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                  Other Lost Reason :
                </p>
                <p className={styles.text}>
                  {location.state.detail.other_lost_reason}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>Created By :</p>
                <p className={styles.text}>
                  {location.state.detail.created_by}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                Created On :
                </p>
                <p className={styles.text}>
                  {/* {getDateAndTime(
                    location.state.detail.created_at,
                    "LLL"
                  )} */}
                    {location.state.detail
                    .created_at
                    ? getDateAndTime(
                      location.state.detail
                        .created_at,
                      "LLL"
                    )
                    : ""}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                Lead Assigned On :
                </p>
                <p className={styles.text}>
                  {/* {getDateAndTime(
                    location.state.detail.lead_assign_time,
                    "LLL"
                  )} */}
                  {location.state.detail
                    .lead_assign_time
                    ? getDateAndTime(
                      location.state.detail
                        .lead_assign_time,
                      "LLL"
                    )
                    : ""}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>Campaign :</p>
                <p className={styles.text}>
                  {location.state.detail.campaign}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                Modified On :
                </p>
                <p className={styles.text}>
                  {/* {location.state.detail.modified_at !== ""
                    ? getDateAndTime(
                      location.state.detail.modified_at,
                      "LLL"
                    )
                    : ""} */}
                       {location.state.detail
                    .modified_at
                    ? getDateAndTime(
                      location.state.detail
                        .modified_at,
                      "LLL"
                    )
                    : ""}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                  Date Of Birth :
                </p>
                <p className={styles.text}>
                  {/* {location.state.detail.dob !==null
                    ? getFormattedDate(
                      location.state.detail
                        .dob
                    )
                    : ""} */}
                                 {location.state.detail
                    .dob
                    ? getDateAndTime(
                      location.state.detail
                        .dob,
                      "LLL"
                    )
                    : ""}
                    {/* {"Male"} */}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                Anniversary Date :
                </p>
                <p className={styles.text}>
                  {/* {location.state.detail.anniversary_date !==null
                    ? getFormattedDate(
                      location.state.detail
                        .anniversary_date
                    )
                    : ""} */}
                                       {location.state.detail
                    .anniversary_date
                    ? getDateAndTime(
                      location.state.detail
                        .anniversary_date,
                      "LLL"
                    )
                    : ""}
                    {/* {"Married"} */}
                </p>
              </div>
              {location.state.detail.lead_sub_type==="Magicleads Gold" && 
              <>
              <div className={styles.data}>
                <p className={styles.heading}>
                  Gender :
                </p>
                <p className={styles.text}>
                    {location.state.detail.gender}
                </p>
              </div>
              <div className={styles.data}>
                <p className={styles.heading}>
                Marital Status :
                </p>
                <p className={styles.text}>
                  {
                      location.state.detail
                        .marital_status
                    
                    }
                    {/* {"Married"} */}
                </p>
              </div>
              </>}

              <div className={styles.data}>
                <p className={styles.heading}>
                  Contact Message Details :
                </p>
                <p className={styles.text}>
                  {location.state.detail.contact_message_details}
                </p>
              </div>
              {
                apiQuestionsData && apiQuestionsData[0] && 
                apiQuestionsData[0].question_3 && (
                  <div className={styles.data}>
                    <p className={styles.heading}>
                    {apiQuestionsData[0].question_3}
                    </p>
                    <p className={styles.text}>
                    {apiQuestionsData[0].answer_3 ? apiQuestionsData[0].answer_3 : ""}
                        {/* {"Married"} */}
                    </p>
                  </div>
                )
              }
                          {
                apiQuestionsData && apiQuestionsData[0] && 
                apiQuestionsData[0].question_4 && (
                  <div className={styles.data}>
                    <p className={styles.heading}>
                    {apiQuestionsData[0].question_4}
                    </p>
                    <p className={styles.text}>
                    {apiQuestionsData[0].answer_4 ? apiQuestionsData[0].answer_4 : ""}
                        {/* {"Married"} */}
                    </p>
                  </div>
                )
              }
            </div>
          </div>
                    {/* ========================================================================================================= */}
                    {/* {location.state.detail.reenquired === true && (
            <>
              <div  style={{width:"100%",marginTop: "20px", display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
            {dataList && dataList.map((item:any,index: any)=>(
              <div  key={index}  style={{ width:"49%", marginBottom: "20px",marginRight:"1%"}} >
              <h6 style={{marginTop:"20px"}}>ReEnquired Lead {index + 1}</h6>
              <div className={styles.contactDetails} style={{...cardContainerStyles,marginTop:"20px"}}>
              <div className={styles.firstContainer}>  
                <div className={styles.nameDiv}>
                  <h6>
                    Name : {item.customer_name
                      .toLowerCase()
                      .split(" ")
                      .map(function (word: any) {
                        return (
                          word.charAt(0).toUpperCase() +
                          word.slice(1)
                        );
                      })
                      .join(" ")}
                  </h6> */}
                  {/* <p
                  >
                    {item.email}
                  </p> */}
                {/* </div>
                <div className={styles.data}>
                  <p className={styles.heading}>Email :</p>
                  <p className={styles.text}>
                  {item.email}
                  </p>
                </div>
                <div className={styles.data}>
                  <p className={styles.heading}>Contact_No :</p>
                  <p className={styles.text}>
                  {item.contact_no}
                  </p>
                </div>
                <div className={styles.data}>
                  <p className={styles.heading}>Location : </p>
                  <p className={styles.text}>
                    {item.location}
                  </p>
                </div>
                
                
              </div>
  
              <div className={styles.secondContainer}>
                <div className={styles.data}>
                  <p className={styles.heading}>
                    Lead Source :
                  </p>
                  <p className={styles.text}>
                    {item.lead_source}
                  </p>
                </div>
                
                <div className={styles.data}>
                  <p className={styles.heading}>Budget :</p>
                  <p className={styles.text}>
                    {item.budget}
                  </p>
                </div>
                <div className={styles.data}>
                  <p className={styles.heading}>Project :</p>
                  <p className={styles.text}>
                    {item.project}
                  </p>
                </div>
              </div>
            </div>
              </div>
            ))}
            </div>
             </>
          )} */}
          {/* ========================================================================================================= */}
          <div className={styles.taskDetails} style={cardContainerStyles}>
            <h6
            // className={styles.task}
            >Tasks</h6>
            <div className={styles.tableContainer}>
              <table className={styles.table}>
                {(taskVerified_status==="Pending") && (taskReporting_to===user.user_email)?<thead className={styles.head}>
                  <tr>
                    <th className={styles.th}>Tasks</th>
                    <th className={styles.th}>Date</th>
                    <th className={styles.th}>Time</th>
                    <th className={styles.th}>
                      Status Type
                    </th>
                    <th className={styles.th}>
                      Approve Visit
                    </th>
                    <th className={styles.th}>
                      Reject Visit
                    </th>
                  </tr>
                </thead>:
                <thead className={styles.head}>
                <tr>
                  <th className={styles.th}>Tasks</th>
                  <th className={styles.th}>Date</th>
                  <th className={styles.th}>Time</th>
                  <th className={styles.th}>
                    Status Type
                  </th>
                </tr>
              </thead>}
                <tbody>
                  {tasksList?.map(
                    (item: any, index: number) => (
                      <>
                      {(item.type==="Site Visit" || item.type==="Meeting") &&(item.status==="Pending" || item.status==="Overdue") &&(taskVerified_status==="Pending") &&(taskReporting_to===user.user_email)?
                      <>
                      {}<tr key={index} style={tdStyles}>
                            <td className={styles.td} style={tdStyles}>
                              {item.type}
                            </td>
                            <td className={styles.td} style={tdStyles}>
                              {/* {item.due_date.toDate
                                ? getDateAndTime(
                                  item.due_date.toDate(),
                                  "DD MMM YY"
                                )
                                : ""} */}
                                {item.due_date
                                ? getDateAndTimeString(
                                  item.due_date,
                                  "DD MMM YY"
                                )
                                : ""}
                            </td>
                            <td className={styles.td} style={tdStyles}>
                              {/* {item.due_date.toDate
                                ? getDateAndTime(
                                  item.due_date.toDate(),
                                  "LT"
                                )
                                : ""} */}
                                {item.due_date
                                ? getDateAndTimeString(
                                  item.due_date,
                                  "LT"
                                )
                                : ""}
                            </td>
                            <td className={styles.td} style={tdStyles}>
                              {/* {item.status==="Pending"?"Upcoming":item.status} */}
                              {item.status==="Pending"? item.due_date < new Date().toISOString() ? "Overdue" : "Upcoming":item.status}
                            </td>
                            <td className={styles.td} style={tdStyles}>
                          <ContactButton
                              backgroundColor="#f7d560"
                              color="#fff"
                              title="Approve"
                              clicked={() => visit_Verifi( item.leadId,
                                "Approved",
                                owner,
                                item.type,
                                item.customer_name,
                                "2",
                                )} />
                              </td>
                              <td>
                              <ContactButton
                              backgroundColor="#ff6961"
                              color="#fff"
                              title="Reject"
                              clicked={() => visit_Verifi( item.leadId,
                                "Rejected",
                                owner,
                                item.type,
                                item.customer_name,
                                "2",
                                )} />
                              </td>
                              </tr></>
                      :
                      <><tr key={index} style={tdStyles}>
                        <td className={styles.td} style={tdStyles}>
                          {item.type}
                        </td>
                        <td className={styles.td} style={tdStyles}>
                          {/* {item.due_date.toDate
                            ? getDateAndTime(
                              item.due_date.toDate(),
                              "DD MMM YY"
                            )
                            : ""} */}
                                {item.due_date
                            ? getDateAndTimeString(
                              item.due_date,
                              "DD MMM YY"
                            )
                            : ""}
                        </td>
                        <td className={styles.td} style={tdStyles}>
                          {/* {item.due_date.toDate
                            ? getDateAndTime(
                              item.due_date.toDate(),
                              "LT"
                            )
                            : ""} */}
                              {item.due_date
                            ? getDateAndTimeString(
                              item.due_date,
                              "LT"
                            )
                            : ""}
                        </td>
                        <td className={styles.td} style={tdStyles}>
                          {/* {item.status==="Pending"?"Upcoming":item.status} */}
                          {item.status==="Pending"? item.due_date < new Date().toISOString() ? "Overdue" : "Upcoming":item.status}
                        </td>
                      </tr></>}
                      </>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className={styles.notesContainer}
          style={containerStyles}
        >
          <div className={styles.childNotes}
            style={containerStyles}
          >
            {
              (isMaskedBoosterLead) &&(
                <BoosterLeadsCard leadData = {location.state.detail}/>
              )
            }
        {/* { projectMB?.leadCount &&  ( <div style={{ borderRadius: "8px", border: "solid 1px #b2dfd8", backgroundImage: "linear-gradient(to right, #fff, #edfaf9)", padding: "16px",}}>
              <div style={{fontSize:"16px", color: "#303030", fontWeight:"500", whiteSpace: "normal",}}>Want more leads for <span style={{color: "#279ea0", fontWeight:"700",}}>Shobha Royal Crest?</span></div>
              <span style={{display: "inline-block", margin: "8px 0px", width: "88px", height:"1px", background:"#b2dfd8"}}></span>
              <div style={{fontSize:"16px", color: "#303030", fontWeight:"400", whiteSpace: "normal",}}>Switch to <span style={{color: "#279ea0", fontWeight:"500",}}>Project Listing</span> pack and get up to <span style={{color: "#303030", fontWeight:"600",}}>{projectMB?.leadCount || "0"} Project-specific responses</span> per project</div>
              <span style={{display: "inline-block", fontSize:"14px", color: "#d8232a", fontWeight:"500", marginTop: "24px", cursor:"pointer"}}>Know More 
                <span style={{display: "inline-block", marginLeft: "8px",}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
                    <path d="M14.758 6.672a.827.827 0 0 0 0-1.17L9.498.243a.827.827 0 1 0-1.17 1.17l4.676 4.675-4.676 4.676a.827.827 0 0 0 1.17 1.17l5.26-5.261zM0 6.087v.827h14.173V5.26H0v.826z" fill="#D8232A"/>
                  </svg>
                </span>
              </span>
            </div>)} */}

            <HtmlBanner   user={user} route={cRoute} bannerType={"contactSideView"} tagObj={location.state.detail}/>
            <div className={styles.notesSection} style={cardContainerStyles}>
              <div className={styles.notesHead}>
                <h6
                // className={styles.notes}
                >Notes</h6>
                <IoIosAddCircleOutline
                  color={isMaskedBoosterLead ? "#d8d8d8":"#279ea0"}
                  size="20"
                  onClick={() => {
                    isMaskedBoosterLead === false && setNoteModal(true)
                  }}
                />
              </div>
              <div className={styles.container}>
                {notesList?.map(
                  (item: any, index: number) => (
                    <div className={styles.noteDisplay}>
                      <div className={styles.box}>
                        <div className={styles.innerBox}>
                          <div
                            className={
                              styles.dateAndCreatedByBox
                            }
                          >
                            <p className={styles.date}>
                              {/* {getDateAndTime(
                                item.created_at.toDate(),
                                "LLL"
                              )} */}
                               {getDateAndTimeString(
                                item.created_at,
                                "LLL"
                              )}
                            </p>
                            <p className={styles.createdBy}>
                              {item.userEmail}
                            </p>
                          </div>
                          <p className={styles.note}>
                            {item.note}
                          </p>
                        </div>
                      </div>
                    </div>
                  )
                )}
                {notesList?.length === 0 && (
                  <p
                    style={{ textAlign: "center" }}
                  // className={styles.noContent}
                  >
                    No Notes{" "}
                  </p>
                )}
              </div>
            </div>
            {audioUrl && <div className={styles.notesSection} style={cardContainerStyles}>
              <div className={styles.notesHead}>
                <h6>Magicleads: Call Recordings</h6>
              </div>
              <div className={styles.recordingContainer}>
                {
                  true && 
                      <>
                        <div className={styles.Callrecords}>
                          Play call recording 
                          <span className={styles.PlayButton} typeof="button" onClick={callRecordPlayHandler}>
                            {!isPlaying ? <PlayArrowIcon /> : <PauseIcon />}
                            {/* <span className={styles.PlayTime}></span> */}
                          </span>
                        </div>
                        {
                          showCallRecordings && 
                            <CallRecordingsPlayer 
                              setShowCallRecordings={setShowCallRecordings} 
                              audioUrl={audioUrl}
                              setIsPlaying={setIsPlaying}
                              callbackFunction={handleCallback}
                            />
                        }
                      </>
                  
                }
                {false && (
                  <p
                    style={{ textAlign: "center" }}
                  >
                    No Call Recordings{" "}
                  </p>
                )}
              </div>
            </div>}
            {(imageMGUrl && !audioUrl) && <div className={styles.notesSection} style={cardContainerStyles}>
              <div className={styles.ImageBoxHeading}>
                Magicleads: Buyer consent proof
              </div>
              <div className={styles.recordingContainer}>
                <div className={styles.Callrecords}>
                  <span className={styles.ImageBox}>
                    <img src={imageMGUrl} alt="image" />
                  </span>
                </div>
                <span className={styles.ClickToZoon} onClick={showZoomedImgHandler}>Click to zoom <HiExternalLink size={15} color="#279ea0" /></span>
                {
                  showZoomedImg && 
                  <CenteredPopUp
                    setModal={setShowZoomedImg}
                    children={
                      <div className={styles.ImageBoxFull}>
                        <img src={imageMGUrl} alt="image" />
                      </div>
                    }
                    modiferClass={styles.TabpImageBox}
                    closeIcon={true}
        />
                }
              </div>
            </div>}
            <div className={styles.attachmentSection} style={cardContainerStyles}>
              <div className={styles.notesHead}>
                <h6
                // className={styles.notes}
                >Attachments</h6>
                {/* <IoIosAddCircleOutline color="#279ea0" size="20" /> */}
                <div className={styles.attachmentItems}>
                  <div style={{ padding: "0 10px" }}>
                    <HiVideoCamera
                      size={15}
                      color={isMaskedBoosterLead ? "#d8d8d8" : "#279ea0"}
                      onClick={() => {
                        isMaskedBoosterLead === false &&
                        setVidModal(true);
                        setTitle("Upload Video");
                      }}
                    />
                  </div>
                  <div style={{ padding: "0 10px" }}>
                    <HiOutlinePhotograph
                      size={15}
                      color={isMaskedBoosterLead ? "#d8d8d8":"#279ea0"}
                      onClick={() => {
                        isMaskedBoosterLead === false &&
                        setPicModal(true);
                        setTitle("Upload Image");
                      }}
                    />
                  </div>
                  <div style={{ padding: "0 10px" }}>
                    <ImFileText2
                      size={15}
                      color={isMaskedBoosterLead ? "#d8d8d8":"#279ea0"}
                      onClick={() => {
                        isMaskedBoosterLead === false &&
                        setFileModal(true);
                        setTitle("Upload Files");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.attachmentContainer}>
                {load && <Loading />}
                {attachmentsList?.map(
                  (item: any, index: number) => (
                    <div
                      className={styles.attachmentBox}
                      key={index}
                    >
                      {item.type === "video" && (
                        <HiVideoCamera
                          size={15}
                          color="#279ea0"
                        />
                      )}
                      {item.type === "photo" && (
                        <HiOutlinePhotograph
                          size={15}
                          color="#279ea0"
                        />
                      )}
                      {item.type === "audio" && (
                        <HiOutlineMicrophone
                          size={15}
                          color="#279ea0"
                        />
                      )}
                      {item.type === "file" && (
                        <ImFileText2
                          size={15}
                          color="#279ea0"
                        />
                      )}
                      <p className={styles.note}>
                        <a href={item.S3url ? item.S3url:item.url}>{item.name}</a>
                      </p>
                    </div>
                  )
                )}
                {attachmentsList?.length === 0 && (
                  <p
                    style={{ textAlign: "center" }}
                  // className={styles.noContent}
                  >
                    No Attachments{" "}
                  </p>
                )}
              </div>
            </div>
            <div className={styles.notesSection} style={cardContainerStyles}>
              <div className={styles.notesHead}>
                <h6
                // className={styles.notes}
                >Call Logs</h6>
                {/* <IoIosAddCircleOutline
                  color="#279ea0"
                  size="20"
                /> */}
              </div>
              <div className={styles.attachmentContainer}>
                {callLogsList?.map(
                  (item: any, index: number) => (
                    <div
                      className={styles.attachmentBox}
                      key={index}
                    >
                      <HiPhone size={50} color="#279ea0" />

                      <p className={styles.note}>
                        {/* Before Migration
                        {item.callTime} */}

                        {/* After Migration */}
                        {/* {item.duration} */}
                        {convertSecondsToTime(item.duration)}
                      </p>
                      <p
                        className={styles.note}
                        style={{ marginLeft: "auto" }}
                      >
                        {/* Before Migration
                        {getDateAndTime(
                          item.created_at.toDate(),
                          "LLL"
                        )} */}

                        {/* After Migration */}
                        {getDateAndTimeString(
                          item.created_at,
                          "LLL"
                        )}
                      </p>
                    </div>
                  )
                )}
                {callLogsList?.length === 0 && (
                  <p
                    style={{ textAlign: "center" }}
                  // className={styles.noContent}
                  >
                    No Call Logs{" "}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        {ownerButton && (
          <OwnerModal
            open={ownerButton}
            close={() => {
              setOwnerButton(false);
              history.push("/");
            }}
            usersList={usersList}
            rowsSelected={[location.state.detail]}
            organization_id={user.organization_id}
            freshFilterValue={freshFilterValue}
          />
        )}

        {picModal && (
          <AttachmentModal
            open={picModal}
            close={() => setPicModal(false)}
            title={title}
            type={"photo"}
            contactDetail={location.state.detail}
            attachmentsList={
              attachmentsList ? attachmentsList : []
            }
          />
        )}
        {vidModal && (
          <AttachmentModal
            open={vidModal}
            close={() => setVidModal(false)}
            title={title}
            type={"video"}
            contactDetail={location.state.detail}
            attachmentsList={
              attachmentsList ? attachmentsList : []
            }
          />
        )}
        {fileModal && (
          <AttachmentModal
            open={fileModal}
            close={() => setFileModal(false)}
            title={title}
            type={"file"}
            contactDetail={location.state.detail}
            attachmentsList={
              attachmentsList ? attachmentsList : []
            }
          />
        )}
        {interestedModal === true && (
          <InterestedLeadModal
            contactDetail={location.state.detail}
            close={() => setInterestedModal(false)}
            open={interestedModal}
            notes={notesList ? notesList : []}
            tasksData={tasksList ? tasksList : []}
          />
        )}
        {notInterestedModal === true && (
          <NotInterestedLeadModal
            contactDetail={location.state.detail}
            close={() => setNotInterestedModal(false)}
            open={notInterestedModal}
            tasksData={tasksList ? tasksList : []}
            notes={notesList ? notesList : []}
          />
        )}
        {callbackModal === true && (
          <CallBackModal
            contactDetail={location.state.detail}
            close={() => setCallbackModal(false)}
            open={callbackModal}
            tasksData={tasksList ? tasksList : []}
            notes={notesList ? notesList : []}
          />
        )}
        {lostModal === true && (
          <LostModal
            contactDetail={location.state.detail}
            close={() => setLostModal(false)}
            open={lostModal}
            tasksData={tasksList ? tasksList : []}
            notes={notesList ? notesList : []}
          />
        )}
        {createModal === true && (
          <CreateModal
            contactDetail={location.state.detail}
            close={() => setCreateModal(false)}
            open={createModal}
            tasksData={tasksList ? tasksList : []}
            notes={notesList ? notesList : []}
            taskVerified_status={taskVerified_status}
          />
        )}
        {/* {approveModal === true && (
          <ApprovalModal
            // contactDetail={location.state.detail}
            close={() => setApproveModal(false)}
            open={approveModal}
            title={"Please Complete Your Previous Approvel Request For Existing Task"}
            // tasksData={tasksList ? tasksList : []}
            // notes={notesList ? notesList : []}
          />
        )} */}
        {rescheduleModal === true && (
          <RescheduleModal
            contactDetail={location.state.detail}
            close={() => setRescheduleModal(false)}
            open={rescheduleModal}
            tasksData={tasksList ? tasksList : []}
            notes={notesList ? notesList : []}
          />
        )}
        {noteModal === true && (
          <NotesModal
            notes={notesList ? notesList : []}
            contactDetail={location.state.detail}
            close={() => setNoteModal(false)}
            open={noteModal}
            userEmail={user.user_email}
          />
        )}
      </div>
    </div>
        </>
      }
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
    userPreference:state.userPreference.data
  };
};

export default connect(mapStateToProps)(ContactDetails);